<section class="relative flex flex-col items-center w-full min-w-0 overflow-x-hidden">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 px-2 sm:px-3">
    <header class="min-w-0">
      <h1 class="text-xl sm:text-2xl font-semibold text-gray-900">Transmettre</h1>
      <p class="text-sm text-gray-500 mt-1">Sélectionnez les documents prêts à être envoyés sur vos plateformes.</p>
    </header>

    <article class="rounded-xl border border-gray-200 bg-white shadow-sm min-w-0 overflow-hidden">
      @if (loading()) {
        <p class="text-sm text-gray-500 p-5">Chargement...</p>
      } @else if (!items().length) {
        <div class="p-5 text-sm text-gray-500 flex items-center gap-2">
          <span class="material-symbols-outlined">draft</span>
          Aucun document n'est disponible pour la transmission.
        </div>
      } @else {
        <ul class="md:hidden divide-y divide-gray-100">
          @for (item of items(); track item.id) {
            <li class="p-4 flex flex-col gap-1">
              <p class="text-sm font-medium text-gray-800 break-words">{{ item.name }}</p>
              <p class="text-xs text-gray-500">{{ item.type }} · {{ item.date | date: 'dd/MM/yyyy HH:mm' }}</p>
            </li>
          }
        </ul>

        <div class="hidden md:block overflow-x-auto">
          <table class="w-full text-sm">
            <thead class="bg-gray-50 text-gray-600">
            <tr>
              <th class="text-left px-4 py-3 font-medium">Document</th>
              <th class="text-left px-4 py-3 font-medium">Type</th>
              <th class="text-left px-4 py-3 font-medium">Date</th>
            </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
              @for (item of items(); track item.id) {
                <tr>
                  <td class="px-4 py-3 text-gray-800">{{ item.name }}</td>
                  <td class="px-4 py-3 text-gray-600">{{ item.type }}</td>
                  <td class="px-4 py-3 text-gray-500 whitespace-nowrap">{{ item.date | date: 'dd/MM/yyyy HH:mm' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </article>

    <article class="rounded-xl border border-secondary/20 bg-secondary/10 p-4 text-sm text-gray-800">
      <p class="font-medium">Conseil de transmission</p>
      <p class="mt-1">Vérifiez vos dates de validité avant envoi vers Provigis, Approval ou vos destinataires email.</p>
    </article>
  </div>
</section>
